import * as brandColors from './brand-colors';

const drawerWidth = 240;
const drawerClosedWidth = 52;

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    position: 'relative',
    display: 'flex',
  },
  drawerContainer: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '@media print': { display: 'none' },
  },
  drawerContainerClose: {
    width: drawerClosedWidth,
    '@media print': { display: 'none' },
  },
  drawerContainerFullScreen: {
    width: 0,
    '@media print': { display: 'none' },
  },
  menuButton: {
    marginLeft: 12,
    marginRight: 36,
  },
  hide: { display: 'none' },
  drawerPaper: {
    position: 'fixed',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    '& a': { color: brandColors.grey[700] },
    overflowX: 'hidden',
    '@media print': { display: 'none' },
  },
  drawerPaperClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: drawerClosedWidth,
    '@media print': { display: 'none' },
  },
  drawerPaperFullScreen: {
    width: 0,
    '@media print': { display: 'none' },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    flex: 1,
    display: 'inline-block',
    width: `calc(100vw - ${drawerWidth}px)`,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  contentDrawerClosed: {
    flexGrow: 1,
    flex: 1,
    display: 'inline-block',
    width: `calc(100vw - ${drawerClosedWidth}px)`,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  contentWithoutMenu: {
    display: 'inline-block',
    maxWidth: '100vw',
  },
  flex: {
    display: 'flex',
    flexDirection: 'column',
  },
  scroll: {
    flex: 1,
    overflowY: 'auto',
    overflowX: 'hidden',
  },
  listSubheader: {
    color: brandColors.grey.main,
    transition: theme.transitions.create('color', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    padding: '2em 2em .5em',
    lineHeight: '20px',
  },
  listSubheaderClosed: {
    padding: '2em 2em .5em',
    transition: theme.transitions.create('color', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  drawer: {
    paddingBottom: '1em',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    '@media print': { display: 'none' },
  },
  onboardingProgress: {
    padding: '1rem',
    textAlign: 'center',
  },
  onboardingProgressSmall: {
    paddingRight: 5,
    paddingLeft: 5,
    padding: '1rem',
    textAlign: 'center',
  },
  trialDaysChip: {
    margin: 'auto',
    fontWeight: 500,
  },
});

export default styles;
